<template>
  <div class="data-field">
    <div class="data-table">
      <div class="table-title">
        Liste des utilisateurs
        <div>
          <button
            type="button"
            class="add-button"
            data-toggle="modal"
            data-target="#newUserModal"
          >
            Ajouter un utilisateur
            <!-- <i class="fa fa-plus"></i> -->
          </button>
        </div>
      </div>
      <div class="table-header row">
        <div class="col-3" @click="sortTable('email')"><i class="fas fa-sort mr-2"></i> Email</div>
        <div class="col-2" @click="sortTable('company')"><i class="fas fa-sort mr-2"></i>Société</div>
        <div class="col" @click="sortTable('role')"><i class="fas fa-sort mr-2"></i>Role</div>
        <div class="col" @click="sortTable('apps')"><i class="fas fa-sort mr-2"></i>Apps</div>
        <div class="col-2" @click="sortTable('date')"><i class="fas fa-sort mr-2"></i>Inscrit</div>
        <div class="col-2" @click="sortTable('date')"><i class="fas fa-sort mr-2"></i>Last co.</div>
      </div>
      <div
        class="table-row row align-items-center"
        v-for="user in sortedUserList"
        v-bind:key="user.id_user"
        @click="go_to_user(user.id_user)"
      >
        <div class="col-3 user-cell email">  <span class="table-header pr-2">{{ user.last_name }} {{ user.first_name }}</span> <br> {{ user.email }} </div>
        <div class="col-2 user-cell">{{ user.company }}</div>
        <div class="col user-cell">
          {{
            roleList.find((role) => role.id_role == user.id_role)?.role_display
          }}
        </div>
        <div class="col user-cell">
          {{
            user?.apps.length ? "Fleet " : ""
          }}
          <div  v-for="product in user.products" v-bind:key="product.id">
            {{
            product?.product_name
          }}
          </div>
       
        </div>
        <div class="col-2 user-cell">{{ formatDate(user.created_at) }}</div>
        <div class="col-2 user-cell">{{ user.last_connection ? formatDate(user.last_connection, "from") : "" }}</div>
      </div>
      <!-- Modal user -->
      <div
        class="modal fade"
        id="newUserModal"
        tabindex="-1"
        aria-labelledby="newUserModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="newUserModalLabel">
                Nouvel utilisateur
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                ref="closeButtonModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form v-on:submit.prevent="createUser">
                <div class="form-group">
                  <label>Prénom : </label>
                  <input v-model="form.first_name" class="form-control" required/>
                </div>
                <div class="form-group">
                  <label>Nom : </label>
                  <input v-model="form.last_name" class="form-control" required/>
                </div>
                <div class="form-group">
                  <label>Email : </label>
                  <input
                    v-model="form.email"
                    type="email"
                    class="form-control"
                    required
                  />
                </div>
                <Password class="form-group" v-model="form.password" @passwordvalid="(statepwd) => passwordValid = statepwd"/>
                <div class="form-group">
                  <label>Société : </label>
                  <input
                    v-model="form.company"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>N° de téléphone : </label>
                  <input
                    v-model="form.phone_number"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Rôle : </label>
                  <RoleTab
                    :roles="roleList"
                    @changerole="(id_role) => (form.id_role = id_role)"
                  />
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-block"
                  :disabled="buttonDisabled"
                >
                  Enregistrer
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import { ref, onMounted, onUpdated, computed  } from "vue";
import { useRouter } from "vue-router";
import AdminService from "../../services/AdminService";
import RoleTab from "./RoleTab.vue";
import AuthService from "../../services/AuthService";
import Password from "../../components/LoggedComp/Password.vue"
import { useToast } from "vue-toastification"
import moment from 'moment';

export default {
  components: {
    RoleTab,
    Password
  },
  emits: ["success", "error"],
  setup(_props, { emit }) {
    const router = useRouter();
    const toast = useToast();

    const userList = ref([]);
    const productList = ref([]);
    const roleList = ref({});
    const sortOrder = ref('desc'); // Utilisation de ref pour créer une variable réactive
    const sortColumn = ref('date'); // Utilisation de ref pour créer une variable réactive

    const form = ref({
      first_name: "",
      last_name: "",
      password: "",
      email: "",
      company: "",
      phone_number: "",
    });
    const passwordValid = ref(false); 

    const token = ref("");

    const closeButtonModal = ref(null);

    const buttonDisabled = ref(true);

    const getColumnValue = (item, column) => {
      switch (column) {
        case 'email':
          return item.email;
        case 'last_name':
          return item.last_name;
        case 'company':
          return item.company;
        case 'role':
          return roleList.value.find(role => role.id_role == item.id_role)?.role_display;
        case 'apps':
          return (item.apps.length ? 'Fleet ' : '') + (item.products.length ? 'DAP ' : '');
        case 'date':
          return item.created_at;
        default:
          return '';
      }
    };

    const getData = async (token) => {
      try {
        const data = await AdminService.allUsers(token);
        const products = await AdminService.allProducts(token);
        const roles = await AdminService.allRoles(token);
        userList.value = data.users;
        productList.value = products.appList;
        roleList.value = roles.roleList;
            
      } catch (e) {
        emit("error", e);
      }
    };

    const formatDate = (date, type) => {

      let formattedDate

      if (type === "from") {
        formattedDate = moment(date).fromNow();
      } else {
        formattedDate = moment(date).format('lll');
      }

      return formattedDate;
    }

    const sortTable = (column) => {
      if (sortColumn.value === column) {
        sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
      } else {
        sortColumn.value = column;
        sortOrder.value = 'asc';
      }
    };

    const getSortedUsers = computed(() => {
      const sortedList = [...userList.value];

      if (sortColumn.value) {
        sortedList.sort((a, b) => {
          const valA = getColumnValue(a, sortColumn.value);
          const valB = getColumnValue(b, sortColumn.value);

          if (valA > valB) {
            return sortOrder.value === 'asc' ? 1 : -1;
          } else if (valA < valB) {
            return sortOrder.value === 'asc' ? -1 : 1;
          }

          return 0;
        });
      }

      return sortedList;
    });

    onMounted(async () => {
      token.value = localStorage.getItem("token");
      if (token.value == null || token.value.length == 0) {
        localStorage.removeItem("token");
        router.push("/private");
      }
      await getData(token.value);
    });

    const go_to_user = (id) => {
      router.push(`/private/admin/user/${id}`);
    };

    const createUser = async () => {
      try {
        if (!passwordValid.value) {
          toast.error("Le mot de passe n'est pas valide");
          return
        }
        await AuthService.createUser(form.value, token.value);
        emit("success", "L'utilisateur à bien été créé.");
        form.value.password = ""; 
        form.value = {};
        closeButtonModal.value.click();
        await getData(token.value);
      } catch (e) {
        emit("error", e);
      }
    };

    onUpdated(() => {
      if (form.value.last_name && form.value.first_name && form.value.email && form.value.company && form.value.phone_number && passwordValid) {
        buttonDisabled.value = false;
        return;
      }
      buttonDisabled.value = true;
    })

    

    return {
      go_to_user,
      createUser,
      formatDate,
      userList,
      productList,
      roleList,
      form,
      passwordValid,
      closeButtonModal,
      buttonDisabled,
      sortTable,
      getColumnValue,
      sortOrder, // Retourne la variable réactive pour sortOrder
      sortColumn, // Retourne la variable réactive pour sortColumn
      sortedUserList: getSortedUsers
    };
  },
};
</script>

<style scoped lang="scss">
.data-field {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .data-table {
    margin-bottom: 2em;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border-radius: 5px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
  }
  .table-title {
    font-size: 17px;
    margin-bottom: 1rem;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    .add-button {
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
      border-radius: 25px;
      background-color: var(--mainBlue);
      color: white;
      border: var(--mainBlue) 2px solid;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5;
      padding: 0.5rem 1rem;
      transition: all 0.2s;
    }
  }
  .table-header {
    font-weight: 600;
    background-color: #f2f2f2;
    padding-top: 0.25em;
    padding-bottom: 0.25em;
    padding-left: 1em;
    margin-left: -1rem;
    margin-right: -1rem;
    cursor: pointer;
    font-size: 12px;
  }
  .table-row {
    border-bottom: 1px solid #f2f2f2;
    padding-top: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 1em;
    margin-left: -1rem;
    margin-right: -1rem;
    overflow: hidden;
    transition: all 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
    .user-cell {
      word-break: break-all;
      font-size: 11px;
      .product-logo {
        width: 100%;
      }
    }
    .email {
      transition: all 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }
  .table-row:hover .email {
    color: blue;
  }
  .table-row:hover {
    cursor: pointer;
    background-color: #f8f8f8;
  }
  .table-row:active {
    background-color: #d9d9d9;
  }
}
</style>